import { IProduct } from '../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { Pool } from '../../../../../../../apis/pool.api';

export function P0003602NCCMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.NCC_Controle,
    'ncCResetProtectionMagnetique',
    1,
    null,
    productClass,
  );

  editValue(
    P00039DataRxTxIndex.NCC_Controle,
    'ncCResetProtectionThermique',
    1,
    null,
    productClass,
  );

  return false;
}
